import * as IoC from 'typescript-ioc';
import { IntlShape } from 'react-intl';
import { IEventDetailsDTO } from '../../../../../api/events.dao';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ISubWindowFormMethods } from '../../manage-event.viewmodel';
import { IAttendeeDetailsDTO } from '../../../../../api/attendees.dao';
import { IMeetingDetailsDTO } from '../../../../../api/meetings.dao';
import { MeetingFormPresentation } from './meeting-form.presentation';
import MeetingFormVM from './meeting-form.viewmodel';
import {OpenFrom} from '../../../../../tracking-service/tracking-values';

export interface IMeetingFormContainerProps {
    meetingId: number;
    event: Readonly<IEventDetailsDTO>;
    accountId: number;
    subWindowFormMethods: ISubWindowFormMethods;
    intl: IntlShape;
    saveCompletionCallback: (newMeetingDetails: IMeetingDetailsDTO) => void;
    deleteCompletionCallback?: () => void;
    createAttendee: (callback: (attendee: IAttendeeDetailsDTO) => void) => void;
    openFrom?: OpenFrom;
}

const MeetingFormContainer = withViewModel(MeetingFormPresentation, (props: IMeetingFormContainerProps) => {
    const meetingFormVM = IoC.Container.get<MeetingFormVM>(MeetingFormVM);
    meetingFormVM.initialize(props);
    return meetingFormVM;
}, props => [props.meetingId]);

export { MeetingFormContainer as MeetingForm };
